<template>
  <v-row>
    <v-col v-for="card in resultsCardsMetrics" :key="card.title" cols="3">
      <cbm-card
        :number-text="card.number"
        :title="card.title"
        :is-currency="card.isCurrency"
        :boolean-loader="$apollo.loading"
        :tooltip="card.tooltipText"
        :percentage-tooltip="card.percentageTooltip"
      >
        <template v-if="card.hasPreviousMetrics" #additional>
          <div class="stonks-text-container">
            <mf-stonks variant="percentage" :percentage="card.previousValue" bold />
            <span> x mês anterior</span>
          </div>
        </template>
      </cbm-card>
    </v-col>
  </v-row>
</template>

<script>
import CbmCard from '@/components/CbmCard.vue'
import MfStonks from '@/modules/maria/produtos-impulsionadores/views/components/Step1/MfStonks.vue'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'BenefitBigNumbers',
  components: {
    CbmCard,
    MfStonks,
  },
  props: {
    currentMetrics: {
      type: Object,
      default: () => ({}),
    },
    previousMetrics: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resultsCardsMetrics() {
      return [
        {
          title: 'Faturamento',
          isCurrency: true,
          number: localeString(this.currentMetrics?.benefits_metrics_totals_consumed?.revenue || 0, 2),
          tooltipText: 'Faturamento dos cupons com produtos em oferta.',
          hasPreviousMetrics: true,
          previousValue: this.calcPercentage(
            this.previousMetrics?.benefits_metrics_totals_consumed?.revenue,
            this.currentMetrics?.benefits_metrics_totals_consumed?.revenue
          ),
        },
        {
          title: 'Primeiras compras',
          isCurrency: false,
          number: this.$getLoggedUser().only_mercapromo
            ? localeString(0, 0)
            : localeString(this.currentMetrics?.first_purchase_metrics?.count_with_sales || 0, 0),
          tooltipText: 'Total de consumidores que compraram algum desses produtos pela primeira vez dentro da mensuração da campanha.',
          hasPreviousMetrics: true,
          previousValue: this.$getLoggedUser().only_mercapromo
            ? 0
            : this.calcPercentage(
                this.previousMetrics?.first_purchase_metrics?.count_with_sales,
                this.currentMetrics?.first_purchase_metrics?.count_with_sales
              ),
        },
        {
          title: 'Ticket médio c/ voucher',
          isCurrency: true,
          number: localeString(this.averageTicketWithVoucher, 2),
          tooltipText: 'Ticket médio dos cupons com algum produto da oferta com voucher.',
          hasPreviousMetrics: true,
          previousValue: this.averageTicketWithVoucherPercentage,
        },
        {
          title: 'Ticket médio',
          isCurrency: true,
          number: localeString(this.currentMetrics?.clients_metrics?.total?.average_ticket || 0, 2),
          tooltipText: 'Ticket médio dos cupons com algum produto da oferta.',
          hasPreviousMetrics: true,
          previousValue: this.calcPercentage(
            this.previousMetrics?.clients_metrics?.total?.average_ticket,
            this.currentMetrics?.clients_metrics?.total?.average_ticket
          ),
        },
      ]
    },
    averageTicketWithVoucher() {
      return this.currentMetrics?.benefits_metrics_totals_consumed?.revenue / this.currentMetrics?.benefits_metrics_totals_consumed?.tickets || 0
    },
    averageTicketWithVoucherPercentage() {
      return this.calcPercentage(
        this.previousMetrics?.benefits_metrics_totals_consumed?.revenue / this.previousMetrics?.benefits_metrics_totals_consumed?.tickets,
        this.currentMetrics?.benefits_metrics_totals_consumed?.revenue / this.currentMetrics?.benefits_metrics_totals_consumed?.tickets
      )
    },
  },
  methods: {
    calcPercentage(previousValue, currentValue) {
      if (!previousValue || !currentValue) return 0
      return ((currentValue - previousValue) * 100) / previousValue
    },
  },
}
</script>

<style lang="scss" scoped>
.stonks-text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-left: -5px;

  & span {
    color: $cinza-0;
    font-size: 14px;
  }
}
</style>
